$(document).ready(function () {
  const p = $("body").attr("p");

  if (p === "admin_organizer_setting") {
    let originalValues = {};
    let currentEditingButton = null;

    function storeOriginalValues() {
      originalValues = {
        connect_username: $("#connect_username").val(),
        connect_password: $("#connect_password").val(),
      };
    }

    $(document).on(
      "click",
      "#edit-connect-username, #edit-connect-password",
      function () {
        let inputField = $(this).data("input-field");

        $(`#${inputField}`).prop("disabled", false);
        $(`#${inputField}`).focus();
        $(this).hide();
        $(this).siblings(".form-actions").removeClass("d-none");
        $(this)
          .siblings(".form-actions")
          .find(".saveCredentialsBtn")
          .prop("disabled", true);
      },
    );

    storeOriginalValues();

    $(document).on("focus", "#connect_password", function () {
      $(this).attr("type", "text");
    });

    $(document).on("blur", "#connect_password", function () {
      $(this).attr("type", "password");
    });

    $(document).on(
      "input",
      "#connect_username, #connect_password",
      function () {
        const inputField = $(this).attr("id");
        if ($(this).val() == "") {
          $(this).siblings().find(".saveCredentialsBtn").prop("disabled", true);
          return;
        }

        if ($(this).val() !== originalValues[inputField]) {
          $(this)
            .siblings()
            .find(".saveCredentialsBtn")
            .prop("disabled", false);
        } else {
          $(this).siblings().find(".saveCredentialsBtn").prop("disabled", true);
        }
      },
    );

    $(".cancelEditBtn").on("click", function () {
      var parentDiv = $(this).parent();
      parentDiv.addClass("d-none");
      parentDiv.siblings(".material-icons").show();
      const inputField = parentDiv
        .siblings(".material-icons")
        .data("input-field");
      $(`#${inputField}`).val(originalValues[inputField]);
      $(`#${inputField}`).prop("disabled", true);
    });

    $(document).on("click", ".saveCredentialsBtn", function () {
      currentEditingButton = $(this)
        .closest(".form-actions")
        .siblings(".material-icons");
      $("#credentialsForm").submit();
    });

    $("#credentialsForm").on("submit", function (e) {
      e.preventDefault();
      $("#credentials-errors-message").addClass("d-none");
      $("#credentials-error-text").text("");

      const form = $(this);
      const formData = {};
      form.serializeArray().forEach(function (item) {
        if (item.value && item.value.trim() !== "") {
          formData[item.name] = item.value;
        }
      });

      const saveBtn = currentEditingButton
        ? currentEditingButton
            .siblings(".form-actions")
            .find(".saveCredentialsBtn")
        : $(".saveCredentialsBtn");
      const cancelBtn = currentEditingButton
        ? currentEditingButton.siblings(".form-actions").find(".cancelEditBtn")
        : $(".cancelEditBtn");
      const saveBtnText = saveBtn.text();

      saveBtn.prop("disabled", true);
      cancelBtn.prop("disabled", true);
      saveBtn.empty().append('<div class="loader"></div>');

      $.ajax({
        url: "/api/v1/private/admin/update-connect-cloud-credential",
        method: "POST",
        data: formData,
      })
        .done(function (data) {
          storeOriginalValues();
          currentEditingButton.siblings(".form-actions").addClass("d-none");
          currentEditingButton.show();
          if (
            currentEditingButton.attr("data-input-field") == "connect_username"
          ) {
            $("#connect_username").prop("disabled", true);
          } else if (
            currentEditingButton.attr("data-input-field") === "connect_password"
          ) {
            $("#connect_password").prop("disabled", true);
          }
          currentEditingButton = null;
        })
        .fail(function (xhr) {
          if (
            xhr.responseJSON.redirect_url !== undefined &&
            xhr.responseJSON.redirect_url !== null
          ) {
            document.location.href = xhr.responseJSON.redirect_url;
            return;
          }

          if (xhr.responseJSON && xhr.responseJSON.message) {
            $("#credentials-errors-message").removeClass("d-none");
            $("#credentials-error-text").text(xhr.responseJSON.message);
          }
        })
        .always(function () {
          saveBtn.prop("disabled", false);
          cancelBtn.prop("disabled", false);
          saveBtn.empty().text(saveBtnText);
        });
    });
  }
});
